import type { ReactNode } from 'react';
import { createContext, useContext, useMemo } from 'react';

import type { ImageStyleGuidance, SiteBrandContext } from '@/types/page';

export interface SiteAiContextValue extends SiteBrandContext {
  imageStyleGuidance?: ImageStyleGuidance;
}

const SiteAiContext = createContext<SiteAiContextValue | null>(null);

interface SiteAiProviderProps extends SiteAiContextValue {
  children: ReactNode;
}

export function SiteAiProvider({
  children,
  preferences,
  imageStyleGuidance,
  firmContext,
}: SiteAiProviderProps) {
  const value = useMemo(
    () => ({ preferences, imageStyleGuidance, firmContext }),
    [preferences, imageStyleGuidance, firmContext],
  );

  return <SiteAiContext.Provider value={value}>{children}</SiteAiContext.Provider>;
}

export function useSiteAiContext(): SiteAiContextValue {
  const context = useContext(SiteAiContext);
  if (!context) {
    throw new Error('useSiteAiContext must be used within a SiteAiProvider.');
  }
  return context;
}
